import {
  Autocomplete,
  InputLabel,
  Select,
  Stack,
  styled,
  TextField,
} from '@mui/material';

export const StyledStack = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  gap: '0.7rem',
  padding: '1rem',
  height: '100%',
  margin: '0 0 1rem 0',
  '&:last-of-type': { marginBottom: 0 },
}));
export const StyledTextField = styled(TextField)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(1.5),
  },
  '& .MuiInputBase-root::after, & .MuiInputBase-root::before, .Mui-error::before':
    {
      borderBottomColor: 'transparent',
    },
  '& .MuiInputBase-input': {
    borderRadius: 0,
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    border: 'none',
    fontSize: '1rem',
    width: '100%',
    padding: '10px 12px',
  },
  '& .MuiInput-root:before': {
    borderBottomColor: 'transparent !important',
  },
  '& .MuiInput-root:hover:not(.Mui-disabled):before': {
    borderBottomColor: 'transparent !important',
  },
  '& .MuiInput-root:after': {
    borderBottomColor: 'transparent !important',
  },
}));
export const StyledSelectField = styled(Select)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(1.5),
  },
  '& .MuiInputBase-input': {
    borderRadius: 0,
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    border: 'none',
    fontSize: '1rem',
    textAlign: 'left',
    width: '100%',
    padding: '10px 12px',
  },

  '&.MuiInputBase-root::after': {
    borderBottomColor: 'transparent',
  },
}));
export const StyledAutoComplete = styled(Autocomplete)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(1.5),
  },
  '& .MuiInput-root  .MuiInput-input ': {
    borderRadius: 0,
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    border: 'none',
    fontSize: '1rem',
    textAlign: 'left',
    width: '100%',
    padding: '10px 12px',
    '& :hover, .MuiInputBase-root::after, & .MuiInputBase-root::before, .Mui-error::before ':
      {
        borderBottomColor: 'transparent',
      },
  },
  '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent',
  },
  '& .MuiAutocomplete-endAdornment': {
    backgroundColor: theme.palette.common.white,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  fontSize: '1rem',
  fontFamily: theme.typography.fontFamily,
  fontWeight: 500,
  color: theme.palette.common.black,
  transform: 'scale(1)',
  '&.Mui-focused': {
    color: theme.palette.common.black,
  },
}));
